import { blue } from "./blue.js";
import { interleave } from "./utils.js";
const green = (opts) => interleave(blue(opts), blue(opts));
export {
  green
};
